import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-new-energy-and-ancillary',
  templateUrl: './new-energy-and-ancillary.component.html',
  styleUrls: ['./new-energy-and-ancillary.component.scss'],
})
export class NewEnergyAndAncillaryComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  energyAncillaryData: any;
  energyAncillaryForm!: FormGroup;
  energyAncillaryAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  organizationlist: any;
  energyAncillaryList: any;
  regionList: any;
  selectOrganization: any;
  regionData: any;
  selectRegion: any;
  setIndicatorData: any;
  indicatorList: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  @Output() saveNewEnergyAndAncillaryEvent = new EventEmitter<any>();
  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private administratorService: AdministratorService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.energyAncillaryData =
      this.modal?.modalService?.config?.initialState?.['newEnergyAncillaryData'];
    this.isDisabledDropDown = this.modalLabel == 'Review energy detail' ? true : false;

    const placeHolderOrganization = {
      name: 'All organization',
    };

    const newOrganizationlist = [placeHolderOrganization].concat(
      this.energyAncillaryData.organizationList
    );

    this.indicatorList = this.energyAncillaryData.indicatiorList;
    this.organizationlist = newOrganizationlist;
    this.energyAncillaryList = this.energyAncillaryData.energyProcessItems;
    this.regionList = this.energyAncillaryData.regionItems;
    this.organizatioListFunction();
    this.getRegionData();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.energyAncillaryData.indicatiorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.energyAncillaryForm = new FormGroup(form);
    this.energyAncillaryAddEditForm = this.formBuilder.group({
      energyAncillary: [this.energyAncillaryData.energyProcessId || null, Validators.required],
      region: [null, Validators.required],
      organizationName: [
        this.energyAncillaryData.organizationId || this.organizationlist[0] || null,
      ],
    });
    this.setFormData();
  }

  onClose() {
    this.modal.close();
  }

  onChange(value: any) {
    this.energyAncillaryAddEditForm.controls['region'].setValue(null);
    if (!!value?.id) {
      this.administratorService.GetRegionsForEnergyandAncillary(value.id).subscribe((data: any) => {
        this.regionData = data.data;
      });
    } else {
      this.regionData = [];
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  commonInputSearchForRegion(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.energyAncillaryData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.energyAncillaryData.regionId) {
        return (this.selectRegion = item);
      }
    });
  }

  setFormData() {
    this.energyAncillaryAddEditForm.patchValue({
      region: this.selectRegion,
      organizationName: this.selectOrganization,
    });
  }

  onSave() {
    this.submitted = true;
    if (
      this.energyAncillaryAddEditForm.controls['region'].value?.name == '--Select Region-- ' ||
      (this.activatedRoute == 'energy-and-ancillary' &&
        !this.energyAncillaryAddEditForm.controls['region'].value?.name)
    ) {
      return;
    }
    if (
      this.energyAncillaryAddEditForm.status == 'VALID' &&
      this.energyAncillaryForm.status == 'VALID'
    ) {
      const entires = Object.entries(this.energyAncillaryForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.energyAncillaryData.indicatiorList.map((obj: any, index: any) => ({
        ...obj,
        ...entires[index],
      }));
      entiresArray.forEach((event: any, index: any) => {
        i = {
          indicatorId: event.indicatorId,
          name: event.name,
          unit: event.unit,
          defaultValue: event[1],
          equivalencyUnits: event.equivalencyUnits,
          multiplier: event.multiplier,
        };
        resultArray.push(i);
      });
      const energyAndAncillaryPayload = {
        energyProcessId: this.energyAncillaryAddEditForm.controls['energyAncillary'].value,
        regionId:
          this.energyAncillaryAddEditForm.controls['region'].value?.id ||
          this.energyAncillaryData.regionId,
        organizationId:
          this.energyAncillaryAddEditForm.controls['organizationName'].value?.name ==
            '--All organization -- ' ||
          this.energyAncillaryAddEditForm.controls['organizationName'].value?.name == undefined
            ? null
            : this.energyAncillaryAddEditForm.controls['organizationName'].value?.id,
        indicatiorList: resultArray,
      };

      this.saveNewEnergyAndAncillaryEvent.emit(energyAndAncillaryPayload);
      this.onClose();
    }
  }
}
